import { h, Host, } from "@stencil/core";
export class ContextualMenuItem {
    constructor() {
        this.icon = null;
        this.id = undefined;
    }
    el;
    contextualMenuItemSelected;
    printIcon() {
        if (this.icon !== null) {
            return (h("gxg-icon", { size: "small", type: this.icon, color: "onbackground" }));
        }
    }
    subMenuIcon() {
        const contextualMenuSubmenu = this.el.querySelector("gxg-contextual-menu-submenu");
        if (contextualMenuSubmenu !== null) {
            return (h("gxg-icon", { class: "show-more", size: "regular", type: "navigation/arrow-right", color: "onbackground" }));
        }
    }
    clickHandler = () => {
        this.contextualMenuItemSelected.emit(this.id);
    };
    render() {
        return (h(Host, { onClick: this.clickHandler }, h("li", { class: {
                "contextual-menu-item": true,
                "contextual-menu-item--no-icon": this.icon === null,
            } }, this.printIcon(), h("slot", null), this.subMenuIcon())));
    }
    static get is() { return "gxg-contextual-menu-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["contextual-menu-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["contextual-menu-item.css"]
        };
    }
    static get properties() {
        return {
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Optional icon"
                },
                "attribute": "icon",
                "reflect": false,
                "defaultValue": "null"
            },
            "id": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The id"
                },
                "attribute": "id",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "contextualMenuItemSelected",
                "name": "contextualMenuItemSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=contextual-menu-item.js.map
